const DomainDetailsStyles = {
  textField: {
    width: "80%",
    minWidth: "200px",
    borderRadius: "12px",
    "& .MuiInputBase-input": {
      position: "relative",
      padding: "12px 12px",
      backgroundColor: "#fff",
      "&::placeholder": {
        // ...mediumFont,/
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      "&.Mui-focused fieldset": {
        borderColor: "#4B0150",
      },
    },
    "& .MuiInputBase-input.Mui-disabled": {
      // WebkitTextFillColor: textLightColor,
    },
  },
  requiredValueDescriptionBox: {
    marginTop: "5px",
    display: "flex",
  },
  redInfoIconStyles: { width: "10px" },
  requiredValueInfo: {
    marginLeft: "5px",
    color: "#FF0F00",
  },
} as const;

export default DomainDetailsStyles;
